import type {
  IHttpCall,
  IHttpRequest,
  IHttpResponse,
} from '@hc-frontend/core-utils-net';
import { fetchBasedCall } from '@hc-frontend/core-utils-net';

import { SendEventRequest } from './send-event.types';

type SendEventOptions = Partial<Omit<IHttpRequest<void>, 'body'>> & {
  httpCall?: IHttpCall;
};

export function sendEvent(
  baseUrl: string,
  payload: SendEventRequest,
  options?: SendEventOptions,
): Promise<IHttpResponse<void>> {
  const { httpCall = fetchBasedCall, headers, ...restOptions } = options ?? {};

  const request: IHttpRequest<SendEventRequest> = {
    url: `${baseUrl}/api/v1/blueshift-event`,
    method: 'POST',
    body: payload,
    headers,
    schemas: {
      request: SendEventRequest,
    },
    ...restOptions,
  };

  return httpCall(request);
}
